// extracted by mini-css-extract-plugin
export var cell = "_6x-4";
export var headerCell = "_6x-2";
export var rowHeader = "_6x-3";
export var table = "_6x-1";
export var tableContainer = "_6x-0";